
// capitalize first letter of a string if string is not empty
export const capitalizeFirstLetter = function (string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return '';
};
